import { classNames } from '@/utils';
import { ReactNode } from 'react';
import { ChartError, ChartLoading } from './components/ChartStates';

export interface ChartCardProps {
  /** Card title */
  title?: string;
  /** Card description/subtitle */
  description?: string;
  /** Action buttons or elements */
  actions?: ReactNode;
  /** Chart content */
  children: ReactNode;
  /** Optional CSS class name */
  className?: string;
  /** Loading state for the entire card */
  loading?: boolean;
  /** Error state for the entire card */
  error?: string;
}

export function ChartCard({
  title,
  description,
  actions,
  children,
  className = '',
  loading,
  error,
}: ChartCardProps) {
  return (
    <div
      className={classNames(
        'flex flex-col overflow-hidden rounded-2xl border border-[#E4E7EC] bg-white p-4 shadow-[0px_1px_2px_rgba(20,28,37,0.05)]',
        className,
      )}
    >
      {(title || description || actions) && (
        <div className="mb-2">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              {title && (
                <h3 className="text-sm leading-[17px] font-normal tracking-[-0.01em] text-[#344051]">
                  {title}
                </h3>
              )}
              {description && (
                <p className="mt-1 text-xs text-gray-500">{description}</p>
              )}
            </div>
            {actions && (
              <div className="ml-4 flex items-center gap-2">{actions}</div>
            )}
          </div>
        </div>
      )}

      <div className="relative flex-1">
        {loading ? (
          <ChartLoading fillParent />
        ) : error ? (
          <ChartError error={error} fillParent />
        ) : (
          children
        )}
      </div>
    </div>
  );
}
